import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { EASE_LUXE } from "./Reveal";
import Logo from "@/components/Logo";

export default function AgeGate() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const ok = localStorage.getItem("rv_age_ok");
    if (!ok) setOpen(true);
  }, []);

  const enter = () => {
    localStorage.setItem("rv_age_ok", "1");
    setOpen(false);
  };
  const exit = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-velvet-ink/95 px-6 backdrop-blur-3xl"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          data-testid="age-gate-modal"
        >
          <motion.div
            className="w-full max-w-xl text-center"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, ease: EASE_LUXE, delay: 0.15 }}
          >
            <p className="mb-8 text-xs uppercase tracking-luxe text-velvet-gold">
              Discretion &middot; Elegance &middot; Trust
            </p>
            <h1 className="text-6xl leading-none tracking-tight text-white md:text-7xl">
              <Logo markSize={44} className="text-6xl md:text-7xl" />
            </h1>
            <p className="mx-auto mt-8 max-w-md text-sm font-light leading-relaxed text-white/60">
              This is a premium companionship directory intended strictly for
              adults. By entering you confirm that you are at least 18 years of
              age and consent to viewing curated adult content.
            </p>
            <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <button
                onClick={enter}
                data-testid="age-gate-enter-button"
                className="w-full rounded-full bg-white px-10 py-4 text-xs uppercase tracking-luxe text-black transition-colors duration-500 hover:bg-velvet-gold hover:text-white sm:w-auto"
              >
                I am 18 or older &mdash; Enter
              </button>
              <button
                onClick={exit}
                data-testid="age-gate-exit-button"
                className="w-full rounded-full border border-white/20 px-10 py-4 text-xs uppercase tracking-luxe text-white transition-colors duration-500 hover:bg-white hover:text-black sm:w-auto"
              >
                Exit
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
